import { defineStore } from 'pinia';
import { searchTypeDocs, searchDocuments } from '@/repository/upload.js';
import type { Upload } from '@fibl/oxs-common';
import { useTokenStore } from './token';
import { EAV, SearchRepo } from '@fibl/zdb-common';
import type { Pagination } from '@/repository/search';

export const INS_PROP = {
	width: 100,
	height: 100,
	max: 128,
};

export const SUP_PROP = {
	width: 200,
	height: 200,
	max: 256,
};

export const useUploadStore = defineStore('upload', {
	state: () => ({
		documentsFromOwner: [] as EAV.Entity<Upload.Upload>[],
		cmsDocs: [] as EAV.Entity<Upload.Upload>[],
	}),

	getters: {
		getById() {
			let idx = new Map<string, EAV.Entity<Upload.Upload>>();
			this.documentsFromOwner.forEach(ent => {
				idx.set(ent.id, ent);
			});
			return (id: string): EAV.Entity<Upload.Upload>|undefined => {
				return idx.get(id);
			};
		}
	},

	actions: {

		async ensureDocsLoaded(ids: string[]) {
			let needed = ids.filter(e => !this.getById(e));
			if (needed.length > 0) {
				let res = await SearchRepo.getEntitiesById(needed);
				res.forEach(ent => {
					this.documentsFromOwner.push(ent);
				});
			}
			return ids.map(id => this.getById(id)!);
		},

		async loadForCurrentAccountOwner() {
			const tokenStore = useTokenStore();
			let company = tokenStore.main.account;
			if (!company) return;
			let list = await searchDocuments(
				{ owner: company },
				{ start: 0, limit: 1000 },
				'created:desc',
			);
			this.documentsFromOwner = list;
		},

		addDocumentForOwner(entity: EAV.Entity<Upload.Upload>) {
			let idx = this.documentsFromOwner.findIndex((e) => e.id === entity.id);
			if (idx < 0) {
				this.documentsFromOwner.push(entity);
			} else {
				this.documentsFromOwner.splice(idx, 1, entity);
			}
		},

		async loadCMSDocs(
			pagination: Pagination = { start: 0, limit: 1000 },
			sorting: string = 'created:desc',
			checkOwner: boolean = false,
		) {
			let company = '';
			if (checkOwner) {
				const tokenStore = useTokenStore();
				company = tokenStore.main.account;
				if (!company) return;
			}
			let list = await searchTypeDocs('cms', pagination, sorting, company);
			this.cmsDocs = list;
		},
	},
});
